import ThemedComponent from '../../hoc/ThemedComponent';

import { default as SecurityPageDefault } from './SecurityPage/View';
import { default as SecurityPage3 } from '../../themes/3/pages/security/SecurityPage';
import { default as SecurityPage4 } from '../../themes/4/pages/security/SecurityPage';

const ThemedSecurityPage = {
  default: SecurityPageDefault,
  // 3: SecurityPage3,
  // 4: SecurityPage4,
};

export const SecurityPageView = ThemedComponent(ThemedSecurityPage);
